import { getSubscriptTrail, makeUniversalBlockKey, modelStore } from "./model";
import $ from "jquery"

export function copyRangeToClipboard({scriptId, subscriptId,sizeOfCopy,targetAt,targetOffset,copyEndOffset}){
    
    const {
        model,
        orderedIds,
    } = getSubscriptTrail(modelStore.state,scriptId, subscriptId);

    var textData = "";
    var blockData= [];
    
    for (var a = 0;a<sizeOfCopy;a++) {

        var block = model.Block[makeUniversalBlockKey(scriptId,orderedIds[targetAt+a])];
        var blockType = block.type;
        var text = block.text;
        if (a==0 && (a==sizeOfCopy-1)) {
            text = text.substring(targetOffset,copyEndOffset);
            blockType = 'text';
        } else if (a==0){
            text = text.substring(targetOffset);
        } else if (a==sizeOfCopy-1){
            text = text.substring(0,copyEndOffset);
        }

        blockData.push({
            type : blockType,
            text : text,
            meta : block.meta
        })
        textData = textData?textData+"\n":""
        textData += block.text;
    }

    var jsonData = JSON.stringify({
        jsonType : "blockData",
        blockData : blockData
    });

    navigator.clipboard.write([
        new ClipboardItem({
            'text/plain': new Blob(
                [textData], 
                {type: 'text/plain'}
            ),
            'text/html': new Blob(
                [jsonData],
                { type: 'text/html'}
            )
        })
    ]);

}

export async function getBlocksFromClipboard(onGot) {
  try {
    const clipboardContents = navigator.clipboard.read().then((clipboardContents)=>{
        for (const item of clipboardContents) {
            if (item.types.includes("text/html")) {
                item.getType("text/html").then(jsonBlob=>{
                    jsonBlob.text().then(jsonBlocks=>{
                        try {    
                            var blockData = JSON.parse(jsonBlocks);
                        } catch (error) {
                            var ii=0;
                        }
                        if (blockData && blockData.jsonType=='blockData'){
                            onGot(blockData.blockData);
                        }
                    });
                });
            } else if (item.types.includes("text/plain")) {
                item.getType("text/plain").then(jsonBlob=>{
                    jsonBlob.text().then(text=>{
                        var blockData = textToBlocks(text);
                        onGot(blockData);
                    });
                });;
            }
        }
    });

  } catch (error) {
    console.log(error.message);
  }
}

function textToBlocks(text){

    return modelStore.state.getFocussedSubscriptTypeHandler()?.textToBlocks(text);
    
}